import React from 'react'
import {Link} from 'gatsby'

import {
    EuiText,
    EuiCallOut
  } from '@elastic/eui'

function PrimaryBox() {
  return (
    <EuiCallOut size="m" iconType="alert" title="Updates:">
        <EuiText>
          <ul>
              <li><Link to="/Frequently_Asked_Question/WQHD_Motion_Detection_Areas/">WQHD Kameras und die Bewegungserkennungsbereiche</Link></li>
              <li><Link to="/Frequently_Asked_Question/WQHD_Motion_Detection_Day_Night_Mode/">Unterschiede zwischen dem Tag und Nacht Bewegungserkennungsmodus</Link></li>
          </ul>
        </EuiText>
    </EuiCallOut>
  );
}

export default PrimaryBox

